import React from 'react';
import PropTypes from 'prop-types';

class CustomAlertTemplate extends React.Component {
  static propTypes = {
    classNames: PropTypes.string
  };

  render() {
    const { classNames, id, styles, message, customFields } = this.props;

    let imgMessage = customFields.avatarImg ? <img src={customFields.avatarImg} alt="presentation" /> : '';

    return (
      <div className={classNames} id={id} style={styles}>
        <div className="custom-alert">
          <div className="alert-image-container">{imgMessage}</div>
          <div className="s-alert-box-inner">{message}</div>
        </div>
      </div>
    );
  }
}

export default CustomAlertTemplate;
